module.exports = __webpack_public_path__ + "img/4.565d3374.jpg";